import React from 'react';
import { getSyncType } from 'common/helpers/getSyncType';
import { syncType } from 'common/constants/property';
import { Tooltip } from 'antd';

const SyncType = ({ t, externalSystem }) => {
  const type = getSyncType(externalSystem);
  return (
    <>
      <span>
        {type ? (
          type === syncType.OPEN_API ? (
            t('cms:cms.properties.homepage.property_management.open_api')
          ) : (
            <Tooltip
              title={t('cms:cms.properties.homepage.property_management.integration.tooltip')}
            >
              <span>{t('cms:cms.properties.homepage.property_management.integration.title')}</span>
            </Tooltip>
          )
        ) : (
          '-'
        )}
      </span>
    </>
  );
};

export default SyncType;
